import axios from 'axios';
import { FULFILLMENT_EVENT_TYPES } from '@/shared/types/fulfillmentEvents.types';
import type { ClientFulfillmentEventType, FulfillmentEventMetadata } from '@/shared/types/fulfillmentEvents.types';

export const recordFulfillmentEvent = async (
  eventType: ClientFulfillmentEventType,
  orderId: string,
  metadata?: FulfillmentEventMetadata,
): Promise<void> => {
  try {
    await axios.post('/api/fulfillment-events', { eventType, orderId, ...(metadata ? { metadata } : {}) });
  } catch (error: unknown) {
    console.error('Error recording fulfillment event:', error);
  }
};

/** Record the same label_scan against every order in a batch-orders SKU group. */
export const recordFulfillmentEventsForOrders = async (
  orderIds: readonly string[],
  metadata?: FulfillmentEventMetadata,
): Promise<void> => {
  const ids = orderIds.filter((orderId) => orderId.length > 0);
  if (ids.length === 0) {
    return;
  }
  try {
    await axios.post('/api/fulfillment-events/bulk', {
      eventType: FULFILLMENT_EVENT_TYPES.LABEL_SCAN,
      orderIds: ids,
      ...(metadata ? { metadata } : {}),
    });
  } catch (error: unknown) {
    console.error('Error recording fulfillment event cluster:', error);
  }
};
